import { ModalSize } from '../core/components/Modal/types';

export type LegacyModalSize = 'small' | 'medium' | 'large' | 'xlarge';

enum sizePairs {
  small = 'sm',
  medium = 'md',
  large = 'lg',
  xlarge = 'xl',
}

export const convertLegacyModalSize = (inputSize: LegacyModalSize | ModalSize) => {
  return sizePairs[inputSize] || inputSize;
};
